import { Component, Input } from '@angular/core'

@Component({
  selector: 'dmmp-testimony-stories',
  templateUrl: './testimony-stories.component.html',
})
export class TestimonyStoriesComponent {
  @Input() identifier: string
  @Input() data: any
  @Input() detailLayout: any
}
